import NavBar from '../common/NavBar';

export default function AllProjects()
{
    return (
        <>
            <NavBar />
        </>
    )
}